// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"f1f8bab2","178":"c4e04700","343":"091c7a1a","396":"7c4ad844","521":"21085b71","819":"10611ccf"}[chunkId] + ".css";
};